import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import './styles.scss'

class NonHomeMarketSignOutPopup extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { handleSignOut, show } = this.props
    return (
      <Modal show={show} className="conversion-success-modal rounded-md">
        <Modal.Body className="conversion-success-modal">
          <p className="conversion-success-modal-message mt-0">
            {i18nTranslate(
              'ba_to_member_account_deactivated_missing_requirement',
              'Your account has been deactivated due to missing the 50 DC-SV requirement. Please login to your home market to Re-enroll your account.'
            )}
          </p>

          <div className="row">
            <div className="col-12">
              <Button
                data-testid="qa-none-home-market-signout-button"
                className="none-home-market-signout-button rounded-md"
                variant="primary"
                type="submit"
                onClick={handleSignOut}
                block>
                {i18nTranslate('ba_to_member_sign_out', 'Sign Out')}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default NonHomeMarketSignOutPopup
export { NonHomeMarketSignOutPopup }
